import { IEnvironment } from './tenant.model';

export const environment: IEnvironment = {
  production: false,

  baseApiUrl: 'https://dev.avaana.com.au',
  baseCorporateWellbeingUrl: 'https://corporate-wellbeing.avaana.com.au',
  baseLogicHeathApiUrl: 'https://api-qa-logichealth.avaana.com.au',
  baseEMLWorkcoverUrl: 'https://api-qa-eml.avaana.com.au',
  baseTRINITYWorkcoverUrl: 'https://api-qa-trinity.avaana.com.au',
  baseHIIWorkcoverUrl: 'https://api-qa-hii.avaana.com.au',
  baseBlogUrl: 'https://avaana.com.au/blog',

  baseOwnWorkcoverUrl: 'https://api-qa-eml.avaana.com.au',

  appName: 'EML-QA',

  auth0: {
    domain: 'eml-dev-auth.au.auth0.com',
    clientId: 'cuYbly5pawTc7v1AFPEnja5NguRZPkKI'
  },

  sentry: {
    dsn: 'https://99fc39594eceaa5e75d076866e72e4be@o4507179659624448.ingest.us.sentry.io/4511064733974528',
    tracePropagationTargets: ['https://avaana.com.au', 'https://qa-eml.avaana.com.au']
  },

  clarity: {
    projectId: ''
  },

  gtmId: '',
  googleMapsApiKey: 'AIzaSyCbfv-NcSLHO0FJo90VA0lfR5kflxcpcso',

  mapbox: {
    accessToken: 'pk.eyJ1Ijoia2FtYWwyNzMwIiwiYSI6ImNscjdld210MjIydnMya3BubmN5MG5hbmsifQ.6hr-rtyierLdnUWUK7C9sw',
    style: 'mapbox://styles/kamal2730/clywpcs48008001p6ar1xgizx'
  },

  intercom: {
    appId: 'tl9uvp8y',
    secretKey: 'Rv9dmgDL53AXEhR6HMj7bBIFt_Hkoek4Z7jJi_2-'
  },

  googleAuth: {
    CLIENT_ID: '',
    API_KEY: ''
  },

  branding: {
    title: 'EML',
    faviconAsset: './assets/images/tenants/eml/eml.ico',
    logoAsset: 'assets/images/tenants/eml/eml-logo.svg',
    logoMobileAsset: 'assets/images/tenants/eml/eml-logo.svg',
    logoWhiteAsset: 'assets/images/tenants/eml/eml-logo-new-white-1.png',
    themeColor: '#ffffff'
  },

  recaptchaKey: '6LdGcUwtAAAAAFdzRwq0yw6OUnc_cep39a3SqSfl'
};
